<template>
  <div id="wrapper">

    <side-menu></side-menu>

    <div id="page-wrapper" class="gray-bg">

      <nav-menu></nav-menu>

      <bread-crumps title='Minha Conta' action='Editar'/>

      <div class="wrapper wrapper-content animated fadeIn">

        <spinner size="large" message="Aguarde..." v-if="showSpinner"></spinner>

        <!-- Alteração de Dados -->
        <div class="row">
          <div class="col-lg-7">
            <div class="ibox float-e-margins">
              <div class="ibox-title"> <h5> Alterar dados <small class="required-advice"/></h5> </div>
              <div class="ibox-content">
                <div class="row">
                  <form role="form">

                    <div class="col-sm-5 b-r">

                      <div v-show="false">
                        <input class="form-control" id="file" type="file" name="photo"
                        v-validate="{ required: false, size:100, mimes:[ 'image/jpeg', 'image/png' ] }" @change="previewImage($event)" >
                      </div>

                      <div class="image-prev text-center">
                        <img :src="photo" alt="user image" :class="{invalid: errors.has('photo')}"
                        onclick="document.getElementById('file').click()">
                      </div>

                      <div class="error" v-if="errors.first('photo')">
                        <p>A imagem deve ser menor que <strong>100KB</strong></p>
                      </div>

                    </div>

                    <div class="col-sm-7">
                      <div class="form-group required">
                        <label for="nome" class="control-label" :class="{ invalid: errors.has('nome')}"> Nome </label>
                        <input type="text" class="form-control" name="nome" placeholder="Nome completo..."
                        v-model="user.name" v-validate="'required|min:4|alpha_spaces'" :class="{invalid: errors.has('nome')}">
                        <span class="error">{{ errors.first('nome') }}</span>
                      </div>

                      <div class="form-group required">
                        <label for="email" class="control-label" :class="{ invalid: errors.has('email')}"> Email </label>
                        <input type="email" class="form-control" name="email" placeholder="email"
                        v-model="user.email" v-validate="'required|email'" :class="{invalid: errors.has('email')}">
                        <span class="error">{{ errors.first('email') }}</span>
                      </div>
                    </div>


                    <div class="col-sm-12">
                      <button class="btn btn-w-m btn-success pull-right" :disabled="disable"
                        @click.prevent="updateUser()">
                        Alterar dados
                      </button>

                      <button class="btn btn-w-m btn-danger pull-right" :disabled="disable"
                        v-if="errors.first('photo') || user.photo" style="margin-right: 10px;"
                        @click.prevent="removePhoto()">
                        Remover Imagem
                      </button>
                    </div>

                  </form>

                </div>
              </div>
            </div>
          </div>

          <!-- Alteração de Senha -->
          <div class="col-lg-5">
            <div class="ibox float-e-margins">
              <div class="ibox-title">
                <h5> Alterar senha <a @click="togglePassVisibility()" v-bind:title="passTitle()"><i :class="passIcon()" class="fa"></i></a> <small class="required-advice"/></h5>
              </div>
              <div class="ibox-content">
                <div class="row">
                  <form class="col-sm-12" role="form" @submit.prevent="changePass">

                    <div class="form-group required">
                      <label for="senha_atual" class="control-label" :class="{ invalid: errors.has('senha_atual')}"> Senha atual </label>
                      <input v-model="passChange.currentPass" :type="passInputType()" class="form-control" name="senha_atual" placeholder="Senha atual"
                        v-validate="'required|min:4'" :class="{invalid: errors.has('senha_atual')}">
                      <span class="error">{{ errors.first('senha_atual') }}</span>
                    </div>

                    <div class="form-group required">
                      <label for="nova_senha" class="control-label" :class="{ invalid: errors.has('nova_senha')}"> Senha nova </label>
                      <input v-model="passChange.newPass" :type="passInputType()" class="form-control" name="nova_senha" placeholder="Senha nova"
                        v-validate="'required|min:4'" :class="{invalid: errors.has('nova_senha')}">
                      <span class="error">{{ errors.first('nova_senha') }}</span>
                    </div>

                    <div class="form-group required">
                      <label for="confirm_password" class="control-label" :class="{ invalid: errors.has('confirm_password')}"> Confirmação da senha nova </label>
                      <input v-model="confirm_password" :type="passInputType()" class="form-control" name="confirm_password" placeholder="Confirmação da senha nova"
                        v-validate="{ confirmed: passChange.newPass, required: true }" :class="{invalid: errors.has('confirm_password')}">
                      <span class="error" v-if="errors.first('confirm_password')">Senha e confirmação devem ser iguais</span>
                    </div>

                    <button class="btn btn-w-m btn-success pull-right" type="submit" :disabled="disable">
                      Alterar senha
                    </button>

                  </form>
                </div>
              </div>
            </div>
          </div>

        </div>

        <page-footer></page-footer>

      </div>
    </div>
  </div>
</template>

<script>

import NavMenu from './layout/NavMenu'
import SideMenu from './layout/SideMenu'
import BreadCrumps from './layout/BreadCrumps'
import Spinner from './layout/Spinner'
import PageFooter from './layout/PageFooter'
import { mapGetters, mapActions } from 'vuex'
import { httpService } from '../providers/http-service'
import { toast } from '../mixins/toast'

  export default {
    mixins: [ toast ],
    components: { NavMenu, SideMenu, BreadCrumps, Spinner, PageFooter },
    data () {
      return {
        passVisible: false,
        showSpinner: false,
        disable: false,
        photo:'/static/img/profile.jpg',
        passChange: { currentPass: '', newPass: '' },
        confirm_password: '',
        userStored: {},
        user: { public_key: '' ,name: '', email: '', photo: '' }
      }
    },
    methods: {
      ...mapActions(['setLoggedUser']),

      togglePassVisibility() { this.passVisible = !this.passVisible },
      passIcon() { return this.passVisible ? 'fa-eye' : 'fa-eye-slash' },
      passTitle() { return this.passVisible ? 'Ocultar senhas' : 'Exibir senhas' },
      passInputType() { return this.passVisible ? 'text' : 'password' },

      changePass(event) {
        this.disable = true
        this.$validator.validateAll({
          'senha_atual': this.passChange.currentPass,
          'nova_senha': this.passChange.newPass,
          'confirm_password': this.confirm_password }).then((valid) => {
          if(valid) {
            this.showSpinner = true
            httpService.changePassword(this.passChange).then((res) => {
              if(res.status === 200) {
                this.disable = false
                this.showSpinner = false
                this.resetForm(event)
                this.show_toast('success', 'OK', 'Senha alterada com sucesso!')
              }
            }).catch((err) => {
              this.showSpinner = false
              this.disable = false
              this.show_toast('error', 'Falha ao trocar de senha', 'Por favor, verifique se a senha atual está correta.')
            })
          } else {
            this.disable = false
            this.showSpinner = false
            this.show_toast('warning', 'Atenção', 'Verifique os campos informados!')
            this.$validator.validateAll({
              'senha_atual': this.passChange.currentPass,
              'nova_senha': this.passChange.newPass,
              'confirm_password': this.confirm_password
            })
          }
        })
      },

      updateUser() {
        this.disable = true
        this.$validator.validateAll({'name': this.user.name, 'email': this.user.email}).then((valid) => {
          if(valid) {
            this.showSpinner = true
            httpService.editUser(this.user).then((res) => {
              if(res.status === 200) {

                this.setLoggedUser({
                  id: this.user.public_key,
                  name: this.user.name,
                  email: this.user.email ,
                  img: this.user.photo,
                  token: this.userStored.token,
                  companies: this.userStored.companies
                })

                this.showSpinner = false
                this.disable = false
                this.show_toast('success', 'OK', 'Dados do usuário alterados com sucesso!')
              }
            }).catch((err) => {
              this.showSpinner = false
              this.disable = false
              this.show_toast('error', 'Erro', 'Não foi possível acessar o servidor, por favor tente mais tarde "'+err.message+'"!')
            })
          } else {
            this.disable = false
            this.showSpinner = false
            this.show_toast('warning', 'Atenção', 'Verifique os campos informados!')
            this.$validator.validateAll({'name': this.user.name, 'email': this.user.email})
          }
        })
      },

      resetForm(event) {
        this.$validator.reset()
        this.passChange = { currentPass: '', newPass: '' }
        event.target.reset()
      },

      removePhoto() {
        this.photo = '/static/img/profile.jpg'
        this.user.photo = ''
        this.errors.remove('photo')
      },

      previewImage(event) {
        let input = event.target
        if(input.files && input.files[0]) {
          var reader = new FileReader()
          reader.onload = (e) => {
            this.photo = e.target.result
            this.user.photo = e.target.result
          }
        }
        if(input.files[0]) { reader.readAsDataURL(input.files[0]) }
      }
    },
    mounted() {
      this.userStored = this.$store.state.user

      this.user = {
        public_key: this.userStored.id,
        name: this.userStored.name || '',
        email: this.userStored.email,
        photo: this.userStored.img || ''
      }

      if(this.user.photo) { this.photo = this.user.photo }
    }
  }
</script>

<style scoped>
  .error p {
    margin-top: 4px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/AccountPage.vue